import { useCallback, useRef, useState } from 'react';
import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile';

type TurnstileTheme = 'light' | 'dark' | 'auto';

export const useTurnstileVerification = () => {
  const [token, setToken] = useState<string | null>(null);
  const ref = useRef<TurnstileInstance>(null);
  const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
  const enabled = Boolean(siteKey);

  const reset = useCallback(() => {
    setToken(null);
    ref.current?.reset();
  }, []);

  return {
    enabled,
    ref,
    reset,
    setToken,
    siteKey,
    token,
  };
};

type TurnstileVerificationState = ReturnType<typeof useTurnstileVerification>;

interface TurnstileVerificationProps {
  className?: string;
  theme?: TurnstileTheme;
  verification: TurnstileVerificationState;
}

const TurnstileVerification = ({
  className,
  theme = 'light',
  verification,
}: TurnstileVerificationProps) => {
  if (!verification.enabled || !verification.siteKey) return null;

  return (
    <div className={className}>
      <Turnstile
        ref={verification.ref}
        siteKey={verification.siteKey}
        onSuccess={verification.setToken}
        onError={verification.reset}
        onExpire={verification.reset}
        options={{
          theme,
          size: 'normal',
        }}
      />
    </div>
  );
};

export default TurnstileVerification;
